export default [
    {
        'icon': '😃',
        'title': 'Smileys & People',
        'icons': [
            ["😀", "Grinning Fac"],
            ["😁", "Grinning Face With Smiling Eyes"],
            ["😂", "Face With Tears of Joy"],
            ["😃", "Smiling Face With Open Mouth"],
            ["😄", "Smiling Face With Open Mouth and Smiling Eyes"],
            ["😅", "Smiling Face With Open Mouth and Cold Sweat"],
            ["😆", "Smiling Face With Open Mouth and Tightly-Closed Eyes"],
            ["😉", "Winking Fac"],
            ["😊", "Smiling Face With Smiling Eyes"],
            ["😋", "Face Savouring Delicious Food"],
            ["😎", "Smiling Face With Sunglasses"],
            ["😍", "Smiling Face With Heart-Shaped Eyes"],
            ["😘", "Face Throwing a Kiss"],
            ["😗", "Kissing Fac"],
            ["😙", "Kissing Face With Smiling Eyes"],
            ["😚", "Kissing Face With Closed Eyes"],
            ["☺", "White Smiling Fac"],
            ["😇", "Smiling Face With Halo"],
            ["😐", "Neutral Fac"],
            ["😑", "Expressionless Fac"],
            ["😶", "Face Without Mouth"],
            ["😏", "Smirking Fac"],
            ["😣", "Persevering Fac"],
            ["😥", "Disappointed but Relieved Fac"],
            ["😮", "Face With Open Mouth"],
            ["😯", "Hushed Fac"],
            ["😪", "Sleepy Fac"],
            ["😫", "Tired Fac"],
            ["😴", "Sleeping Fac"],
            ["😌", "Relieved Fac"],
            ["😛", "Face With Stuck-Out Tongu"],
            ["😜", "Face With Stuck-Out Tongue and Winking Ey"],
            ["😝", "Face With Stuck-Out Tongue and Tightly-Closed Eyes"],
            ["☹", "White Frowning Fac"],
            ["😒", "Unamused Fac"],
            ["😓", "Face With Cold Sweat"],
            ["😔", "Pensive Fac"],
            ["😕", "Confused Fac"],
            ["😖", "Confounded Fac"],
            ["😷", "Face With Medical Mask"],
            ["😲", "Astonished Fac"],
            ["😞", "Disappointed Fac"],
            ["😟", "Worried Fac"],
            ["😤", "Face With Look of Triumph"],
            ["😢", "Crying Fac"],
            ["😭", "Loudly Crying Fac"],
            ["😦", "Frowning Face With Open Mouth"],
            ["😧", "Anguished Fac"],
            ["😨", "Fearful Fac"],
            ["😩", "Weary Fac"],
            ["😬", "Grimacing Fac"],
            ["😰", "Face With Open Mouth and Cold Sweat"],
            ["😱", "Face Screaming in Fear"],
            ["😳", "Flushed Fac"],
            ["😵", "Dizzy Fac"],
            ["😡", "Pouting Fac"],
            ["😠", "Angry Fac"],
            ["👿", "Imp"],
            ["😈", "Smiling Face With Horns"],
            ["👦", "Boy"],
            ["👧", "Girl"],
            ["👨", "Man"],
            ["👩", "Woman"],
            ["👴", "Older Man"],
            ["👵", "Older Woman"],
            ["👶", "Baby"],
            ["👱", "Person With Blond Hair"],
            ["👮", "Police Officer"],
            ["👲", "Man With Gua Pi Mao"],
            ["👳", "Man With Turban"],
            ["⛑", "Helmet With White Cross"],
            ["👸", "Princess"],
            ["💂", "Guardsman"],
            ["🎅", "Father Christmas"],
            ["👼", "Baby Angel"],
            ["👯", "Woman With Bunny Ears"],
            ["💆", "Face Massag"],
            ["💇", "Haircut"],
            ["👰", "Bride With Veil"],
            ["🙍", "Person Frowning"],
            ["🙎", "Person With Pouting Fac"],
            ["🙅", "Face With No Good Gestur"],
            ["🙆", "Face With OK Gestur"],
            ["💁", "Information Desk Person"],
            ["🙋", "Happy Person Raising One Hand"],
            ["🙇", "Person Bowing Deeply"],
            ["🙌", "Person Raising Both Hands in Celebration"],
            ["🙏", "Person With Folded Hands"],
            ["👤", "Bust in Silhouett"],
            ["👥", "Busts in Silhouett"],
            ["🚶", "Pedestrian"],
            ["🏃", "Runner"],
            ["💃", "Dancer"],
            ["💏", "Kiss"],
            ["💑", "Couple With Heart"],
            ["👪", "Family"],
            ["👫", "Man and Woman Holding Hands"],
            ["👬", "Two Men Holding Hands"],
            ["👭", "Two Women Holding Hands"],
            ["💪", "Flexed Biceps"],
            ["👈", "White Left Pointing Backhand Index"],
            ["👉", "White Right Pointing Backhand Index"],
            ["☝", "White Up Pointing Index"],
            ["👆", "White Up Pointing Backhand Index"],
            ["👇", "White Down Pointing Backhand Index"],
            ["✌", "Victory Hand"],
            ["🖖", "Raised Hand With Part Between Middle and Ring Fingers"],
            ["✊", "Raised Fist"],
            ["✋", "Raised Hand"],
            ["👊", "Fisted Hand Sign"],
            ["👌", "OK Hand Sign"],
            ["👍", "Thumbs Up Sign"],
            ["👎", "Thumbs Down Sign"],
            ["👋", "Waving Hand Sign"],
            ["👏", "Clapping Hands Sign"],
            ["👐", "Open Hands Sign"],
            ["✍", "Writing Hand"],
            ["💅", "Nail Polish"],
            ["👣", "Footprints"],
            ["👀", "Eyes"],
            ["👂", "Ear"],
            ["👃", "Nos"],
            ["👅", "Tongu"],
            ["👄", "Mouth"],
            ["💋", "Kiss Mark"],
            ["👓", "Eyeglasses"],
            ["👔", "Neckti"],
            ["👕", "T-Shirt"],
            ["👖", "Jeans"],
            ["👗", "Dress"],
            ["👘", "Kimono"],
            ["👙", "Bikini"],
            ["👚", "Womans Clothes"],
            ["👛", "Purs"],
            ["👜", "Handbag"],
            ["👝", "Pouch"],
            ["🎒", "School Satchel"],
            ["👞", "Mans Sho"],
            ["👟", "Athletic Sho"],
            ["👠", "High-Heeled Sho"],
            ["👡", "Womans Sandal"],
            ["👢", "Womans Boots"],
            ["👑", "Crown"],
            ["👒", "Womans Hat"],
            ["🎩", "Top Hat"],
            ["💄", "Lipstick"],
            ["💍", "Ring"],
            ["👹", "Japanese Ogr"],
            ["👺", "Japanese Goblin"],
            ["👻", "Ghost"],
            ["💀", "Skull"],
            ["👽", "Extraterrestrial Alien"],
            ["💩", "Pile of Poo"],
            ["😸", "Grinning Cat Face With Smiling Eyes"],
            ["😹", "Cat Face With Tears of Joy"],
            ["😺", "Smiling Cat Face With Open Mouth"],
            ["😻", "Smiling Cat Face With Heart-Shaped Eyes"],
            ["😼", "Cat Face With Wry Smil"],
            ["😽", "Kissing Cat Face With Closed Eyes"],
            ["😾", "Pouting Cat Fac"],
            ["😿", "Crying Cat Fac"],
            ["🙀", "Weary Cat Fac"],
            ["🌂", "Closed Umbrella"],
            ["🎓", "Graduation Cap"],
            ["💼", "Briefcas"]
        ]
    },
    {
        icon: '🐻',
        title: 'Animals & Nature',
        icons: [
            ["💧","Droplet"],
            ["💦","Splashing Sweat Symbol"],
            ["💨","Dash Symbol"],
            ["🐵","Monkey Face"],
            ["🙈","See-No-Evil Monkey"],
            ["🙉","Hear-No-Evil Monkey"],
            ["🙊","Speak-No-Evil Monkey"],
            ["🐒","Monkey"],
            ["🐶","Dog Face"],
            ["🐕","Dog"],
            ["🐩","Poodle"],
            ["🐺","Wolf Face"],
            ["🐱","Cat Face"],
            ["🐈","Cat"],
            ["🐯","Tiger Face"],
            ["🐅","Tiger"],
            ["🐆","Leopard"],
            ["🐴","Horse Face"],
            ["🐎","Horse"],
            ["🐮","Cow Face"],
            ["🐂","Ox"],
            ["🐃","Water Buffalo"],
            ["🐄","Cow"],
            ["🐷","Pig Face"],
            ["🐖","Pig"],
            ["🐗","Boar"],
            ["🐽","Pig Nose"],
            ["🐏","Ram"],
            ["🐑","Sheep"],
            ["🐐","Goat"],
            ["🐪","Dromedary Camel"],
            ["🐫","Bactrian Camel"],
            ["🐘","Elephant"],
            ["🐭","Mouse Face"],
            ["🐁","Mouse"],
            ["🐀","Rat"],
            ["🐹","Hamster Face"],
            ["🐰","Rabbit Face"],
            ["🐇","Rabbit"],
            ["🐻","Bear Face"],
            ["🐨","Koala"],
            ["🐼","Panda Face"],
            ["🐾","Paw Prints"],
            ["🐔","Chicken"],
            ["🐓","Rooster"],
            ["🐣","Hatching Chick"],
            ["🐤","Baby Chick"],
            ["🐥","Front-Facing Baby Chick"],
            ["🐦","Bird"],
            ["🐧","Penguin"],
            ["🐸","Frog Face"],
            ["🐊","Crocodile"],
            ["🐢","Turtle"],
            ["🐍","Snake"],
            ["🐲","Dragon Face"],
            ["🐉","Dragon"],
            ["🐳","Spouting Whale"],
            ["🐋","Whale"],
            ["🐬","Dolphin"],
            ["🐟","Fish"],
            ["🐠","Tropical Fish"],
            ["🐡","Blowfish"],
            ["🐙","Octopus"],
            ["🐚","Spiral Shell"],
            ["🐌","Snail"],
            ["🐛","Bug"],
            ["🐜","Ant"],
            ["🐝","Honeybee"],
            ["🐞","Lady Beetle"],
            ["💐","Bouquet"],
            ["🌸","Cherry Blossom"],
            ["💮","White Flower"],
            ["🌹","Rose"],
            ["🌺","Hibiscus"],
            ["🌻","Sunflower"],
            ["🌼","Blossom"],
            ["🌷","Tulip"],
            ["☘","Shamrock"],
            ["🌱","Seedling"],
            ["🌲","Evergreen Tree"],
            ["🌳","Deciduous Tree"],
            ["🌴","Palm Tree"],
            ["🌵","Cactus"],
            ["🌾","Ear of Rice"],
            ["🌿","Herb"],
            ["🍀","Four Leaf Clover"],
            ["🍁","Maple Leaf"],
            ["🍂","Fallen Leaf"],
            ["🍃","Leaf Fluttering in Wind"],
            ["🌍","Earth Globe Europe-Africa"],
            ["🌎","Earth Globe Americas"],
            ["🌏","Earth Globe Asia-Australia"],
            ["🌐","Globe With Meridians"],
            ["🌊","Water Wave"],
            ["🌑","New Moon Symbol"],
            ["🌒","Waxing Crescent Moon Symbol"],
            ["🌓","First Quarter Moon Symbol"],
            ["🌔","Waxing Gibbous Moon Symbol"],
            ["🌕","Full Moon Symbol"],
            ["🌖","Waning Gibbous Moon Symbol"],
            ["🌗","Last Quarter Moon Symbol"],
            ["🌘","Waning Crescent Moon Symbol"],
            ["🌙","Crescent Moon"],
            ["🌚","New Moon With Face"],
            ["🌛","First Quarter Moon With Face"],
            ["🌜","Last Quarter Moon With Face"],
            ["☀","Black Sun With Rays"],
            ["🌝","Full Moon With Face"],
            ["🌞","Sun With Face"],
            ["☁","Cloud"],
            ["⛅","Sun Behind Cloud"],
            ["☂","Umbrella"],
            ["☔","Umbrella With Rain Drops"],
            ["❄","Snowflake"],
            ["☃","Snowman"],
            ["🌟","Glowing Star"],
            ["🌠","Shooting Star"],
            ["☄","Comet"],
            ["🔥","Fire"],
            ["⚡","High Voltage Sign"],
            ["⭐","White Medium Star"],
        ]
    },
    {
        icon: '🍔 ',
        title: 'Food & Drink',
        icons: [
            ["🍇","Grapes"],
            ["🍈","Melon"],
            ["🍉","Watermelon"],
            ["🍊","Tangerine"],
            ["🍋","Lemon"],
            ["🍌","Banana"],
            ["🍍","Pineapple"],
            ["🍎","Red Apple"],
            ["🍏","Green Apple"],
            ["🍐","Pear"],
            ["🍑","Peach"],
            ["🍒","Cherries"],
            ["🍓","Strawberry"],
            ["🍅","Tomato"],
            ["🍆","Aubergine"],
            ["🌽","Ear of Maize"],
            ["🍄","Mushroom"],
            ["🌰","Chestnut"],
            ["🍞","Bread"],
            ["🍖","Meat on Bone"],
            ["🍗","Poultry Leg"],
            ["🍔","Hamburger"],
            ["🍟","French Fries"],
            ["🍕","Slice of Pizza"],
            ["🍲","Pot of Food"],
            ["🍱","Bento Box"],
            ["🍘","Rice Cracker"],
            ["🍙","Rice Ball"],
            ["🍚","Cooked Rice"],
            ["🍛","Curry and Rice"],
            ["🍜","Steaming Bowl"],
            ["🍝","Spaghetti"],
            ["🍠","Roasted Sweet Potato"],
            ["🍢","Oden"],
            ["🍣","Sushi"],
            ["🍤","Fried Shrimp"],
            ["🍥","Fish Cake With Swirl Design"],
            ["🍡","Dango"],
            ["🍦","Soft Ice Cream"],
            ["🍧","Shaved Ice"],
            ["🍨","Ice Cream"],
            ["🍩","Doughnut"],
            ["🍪","Cookie"],
            ["🎂","Birthday Cake"],
            ["🍰","Shortcake"],
            ["🍫","Chocolate Bar"],
            ["🍬","Candy"],
            ["🍭","Lollipop"],
            ["🍮","Custard"],
            ["🍯","Honey Pot"],
            ["🍼","Baby Bottle"],
            ["☕","Hot Beverage"],
            ["🍵","Teacup Without Handle"],
            ["🍶","Sake Bottle and Cup"],
            ["🍷","Wine Glass"],
            ["🍸","Cocktail Glass"],
            ["🍹","Tropical Drink"],
            ["🍺","Beer Mug"],
            ["🍻","Clinking Beer Mugs"],
            ["🍴","Fork and Knife"],
            ["🍳","Cooking"],
        ]
    },
    {
        icon: '⚽ ',
        title: 'Activity',
        icons: [
            ["👾","Alien Monster"],
            ["🎪","Circus Tent"],
            ["🎭","Performing Arts"],
            ["🎨","Artist Palette"],
            ["🎰","Slot Machine"],
            ["🚣","Rowboat"],
            ["🛀","Bath"],
            ["🎯","Direct Hit"],
            ["🎫","Ticket"],
            ["⚽","Soccer Ball"],
            ["⚾","Baseball"],
            ["🏀","Basketball and Hoop"],
            ["🏈","American Football"],
            ["🏉","Rugby Football"],
            ["🎾","Tennis Racquet and Ball"],
            ["🎱","Billiards"],
            ["🎳","Bowling"],
            ["⛳","Flag in Hole"],
            ["⛸","Ice Skate"],
            ["🎣","Fishing Pole and Fish"],
            ["🎽","Running Shirt With Sash"],
            ["🎿","Ski and Ski Boot"],
            ["⛷","Skier"],
            ["🏂","Snowboarder"],
            ["🏄","Surfer"],
            ["🏇","Horse Racing"],
            ["🏊","Swimmer"],
            ["⛹","Person With Ball"],
            ["🚴","Bicyclist"],
            ["🚵","Mountain Bicyclist"],
            ["🏆","Trophy"],
            ["🎮","Video Game"],
            ["🎲","Game Die"],
            ["🎷","Saxophone"],
            ["🎸","Guitar"],
            ["🎺","Trumpet"],
            ["🎻","Violin"],
            ["🎬","Clapper Board"],
        ]
    },
    {
        icon: '🌇 ',
        title: 'Travel & Places',
        icons: [
            ["⛰","Mountain"],
            ["🌋","Volcano"],
            ["🗻","Mount Fuji"],
            ["🏠","House Building"],
            ["🏡","House With Garden"],
            ["⛪","Church"],
            ["🏢","Office Building"],
            ["🏣","Japanese Post Office"],
            ["🏤","European Post Office"],
            ["🏥","Hospital"],
            ["🏦","Bank"],
            ["🏨","Hotel"],
            ["🏩","Love Hotel"],
            ["🏪","Convenience Store"],
            ["🏫","School"],
            ["🏬","Department Store"],
            ["🏭","Factory"],
            ["🏯","Japanese Castle"],
            ["🏰","European Castle"],
            ["💒","Wedding"],
            ["🗼","Tokyo Tower"],
            ["🗽","Statue of Liberty"],
            ["⛲","Fountain"],
            ["🌁","Foggy"],
            ["🌃","Night With Stars"],
            ["🌆","Cityscape at Dusk"],
            ["🌇","Sunset Over Buildings"],
            ["🌉","Bridge at Night"],
            ["🗿","Moyai"],
            ["🌌","Milky Way"],
            ["🎠","Carousel Horse"],
            ["🎡","Ferris Wheel"],
            ["🎢","Roller Coaster"],
            ["🚂","Steam Locomotive"],
            ["🚃","Railway Car"],
            ["🚄","High-Speed Train"],
            ["🚅","High-Speed Train With Bullet Nose"],
            ["🚆","Train"],
            ["🚇","Metro"],
            ["🚈","Light Rail"],
            ["🚉","Station"],
            ["🚊","Tram"],
            ["🚝","Monorail"],
            ["🚞","Mountain Railway"],
            ["🚋","Tram Car"],
            ["🚌","Bus"],
            ["🚍","Oncoming Bus"],
            ["🚎","Trolleybus"],
            ["🚏","Bus Stop"],
            ["🚐","Minibus"],
            ["🚑","Ambulance"],
            ["🚒","Fire Engine"],
            ["🚓","Police Car"],
            ["🚔","Oncoming Police Car"],
            ["🚕","Taxi"],
            ["🚖","Oncoming Taxi"],
            ["🚗","Automobile"],
            ["🚘","Oncoming Automobile"],
            ["🚚","Delivery Truck"],
            ["🚛","Articulated Lorry"],
            ["🚜","Tractor"],
            ["🚲","Bicycle"],
            ["⛽","Fuel Pump"],
            ["🚨","Police Cars Revolving Light"],
            ["⚓","Anchor"],
            ["⛵","Sailboat"],
            ["🚣","Rowboat"],
            ["🚤","Speedboat"],
            ["⛴","Ferry"],
            ["🚢","Ship"],
            ["✈","Airplane"],
            ["💺","Seat"],
            ["🚁","Helicopter"],
            ["🚟","Suspension Railway"],
            ["🚠","Mountain Cableway"],
            ["🚡","Aerial Tramway"],
            ["🚀","Rocket"],
            ["🚥","Horizontal Traffic Light"],
            ["🚦","Vertical Traffic Light"],
            ["🚧","Construction Sign"],
            ["🛂","Passport Control"],
            ["🛃","Customs"],
            ["🛄","Baggage Claim"],
            ["🛅","Left Luggage"],
            ["💴","Banknote With Yen Sign"],
            ["💵","Banknote With Dollar Sign"],
            ["💶","Banknote With Euro Sign"],
            ["💷","Banknote With Pound Sign"],
            ["⛩","Shinto Shrine"],
        ]
    },
    {
        icon: '💡 ',
        title: 'Objects',
        icons: [
            ["💌","Love Letter"],
            ["💣","Bomb"],
            ["💎","Gem Stone"],
            ["☠","Skull and Crossbones"],
            ["🗿","Moyai"],
            ["💈","Barber Pole"],
            ["🚪","Door"],
            ["🚽","Toilet"],
            ["🚿","Shower"],
            ["🛁","Bathtub"],
            ["⌛","Hourglass"],
            ["⏳","Hourglass With Flowing Sand"],
            ["⌚","Watch"],
            ["⏰","Alarm Clock"],
            ["⏱","Stopwatch"],
            ["⏲","Timer Clock"],
            ["⛱","Umbrella on Ground"],
            ["🎈","Balloon"],
            ["🎉","Party Popper"],
            ["🎊","Confetti Ball"],
            ["🎌","Crossed Flags"],
            ["🎎","Japanese Dolls"],
            ["🎏","Carp Streamer"],
            ["🎐","Wind Chime"],
            ["🎀","Ribbon"],
            ["🎁","Wrapped Present"],
            ["📯","Postal Horn"],
            ["📻","Radio"],
            ["📱","Mobile Phone"],
            ["📲","Mobile Phone With Rightwards Arrow at Left"],
            ["☎","Black Telephone"],
            ["📞","Telephone Receiver"],
            ["📟","Pager"],
            ["📠","Fax Machine"],
            ["🔋","Battery"],
            ["🔌","Electric Plug"],
            ["💻","Personal Computer"],
            ["⌨","Keyboard"],
            ["💽","Minidisc"],
            ["💾","Floppy Disk"],
            ["💿","Optical Disc"],
            ["📀","DVD"],
            ["🎥","Movie Camera"],
            ["📺","Television"],
            ["📷","Camera"],
            ["📹","Video Camera"],
            ["📼","Videocassette"],
            ["🔍","Left-Pointing Magnifying Glass"],
            ["🔎","Right-Pointing Magnifying Glass"],
            ["🔬","Microscope"],
            ["🔭","Telescope"],
            ["📡","Satellite Antenna"],
            ["💡","Electric Light Bulb"],
            ["🔦","Electric Torch"],
            ["🏮","Izakaya Lantern"],
            ["📔","Notebook With Decorative Cover"],
            ["📕","Closed Book"],
            ["📖","Open Book"],
            ["📗","Green Book"],
            ["📘","Blue Book"],
            ["📙","Orange Book"],
            ["📚","Books"],
            ["📓","Notebook"],
            ["📃","Page With Curl"],
            ["📜","Scroll"],
            ["📄","Page Facing Up"],
            ["📰","Newspaper"],
            ["📑","Bookmark Tabs"],
            ["🔖","Bookmark"],
            ["💰","Money Bag"],
            ["💴","Banknote With Yen Sign"],
            ["💵","Banknote With Dollar Sign"],
            ["💶","Banknote With Euro Sign"],
            ["💷","Banknote With Pound Sign"],
            ["💸","Money With Wings"],
            ["💳","Credit Card"],
            ["✉","Envelope"],
            ["📧","E-Mail Symbol"],
            ["📨","Incoming Envelope"],
            ["📩","Envelope With Downwards Arrow Above"],
            ["📤","Outbox Tray"],
            ["📥","Inbox Tray"],
            ["📦","Package"],
            ["📫","Closed Mailbox With Raised Flag"],
            ["📪","Closed Mailbox With Lowered Flag"],
            ["📬","Open Mailbox With Raised Flag"],
            ["📭","Open Mailbox With Lowered Flag"],
            ["📮","Postbox"],
            ["✏","Pencil"],
            ["✒","Black Nib"],
            ["📝","Memo"],
            ["📁","File Folder"],
            ["📂","Open File Folder"],
            ["📅","Calendar"],
            ["📆","Tear-Off Calendar"],
            ["📇","Card Index"],
            ["📈","Chart With Upwards Trend"],
            ["📉","Chart With Downwards Trend"],
            ["📊","Bar Chart"],
            ["📋","Clipboard"],
            ["📌","Pushpin"],
            ["📍","Round Pushpin"],
            ["📎","Paperclip"],
            ["📏","Straight Ruler"],
            ["📐","Triangular Ruler"],
            ["✂","Black Scissors"],
            ["🔒","Lock"],
            ["🔓","Open Lock"],
            ["🔏","Lock With Ink Pen"],
            ["🔐","Closed Lock With Key"],
            ["🔑","Key"],
            ["🔨","Hammer"],
            ["⛏","Pick"],
            ["⚒","Hammer and Pick"],
            ["🔧","Wrench"],
            ["🔩","Nut and Bolt"],
            ["⚙","Gear"],
            ["⚗","Alembic"],
            ["⚖","Scales"],
            ["🔗","Link Symbol"],
            ["⛓","Chains"],
            ["💉","Syringe"],
            ["💊","Pill"],
            ["🔪","Hocho"],
            ["⚔","Crossed Swords"],
            ["🔫","Pistol"],
            ["🚬","Smoking Symbol"],
            ["⚰","Coffin"],
            ["⚱","Funeral Urn"],
            ["🚩","Triangular Flag on Post"],
            ["🔮","Crystal Ball"],
        ]
    },
    {
        icon: '🔣 ',
        title: 'Symbols',
        icons: [
            ["💘","Heart With Arrow"],
            ["❤","Heavy Black Heart"],
            ["💓","Beating Heart"],
            ["💔","Broken Heart"],
            ["💕","Two Hearts"],
            ["💖","Sparkling Heart"],
            ["💗","Growing Heart"],
            ["💙","Blue Heart"],
            ["💚","Green Heart"],
            ["💛","Yellow Heart"],
            ["💜","Purple Heart"],
            ["💝","Heart With Ribbon"],
            ["💞","Revolving Hearts"],
            ["💟","Heart Decoration"],
            ["❣","Heavy Heart Exclamation Mark Ornament"],
            ["💤","Sleeping Symbol"],
            ["💢","Anger Symbol"],
            ["💬","Speech Balloon"],
            ["💭","Thought Balloon"],
            ["💮","White Flower"],
            ["♨","Hot Springs"],
            ["💈","Barber Pole"],
            ["🚳","No Bicycles"],
            ["🔱","Trident Emblem"],
            ["🏧","Automated Teller Machine"],
            ["🚮","Put Litter in Its Place Symbol"],
            ["🚫","No Entry Sign"],
            ["🚭","No Smoking Symbol"],
            ["🚯","Do Not Litter Symbol"],
            ["🚰","Potable Water Symbol"],
            ["🚱","Non-Potable Water Symbol"],
            ["🚷","No Pedestrians"],
            ["🚸","Children Crossing"],
            ["♿","Wheelchair Symbol"],
            ["🚹","Mens Symbol"],
            ["🚺","Womens Symbol"],
            ["🚻","Restroom"],
            ["🚼","Baby Symbol"],
            ["🚾","Water Closet"],
            ["⚠","Warning Sign"],
            ["⛔","No Entry"],
            ["🕛","Clock Face Twelve O'Clock"],
            ["🕧","Clock Face Twelve-Thirty"],
            ["🕐","Clock Face One O'Clock"],
            ["🕜","Clock Face One-Thirty"],
            ["🕑","Clock Face Two O'Clock"],
            ["🕝","Clock Face Two-Thirty"],
            ["🕒","Clock Face Three O'Clock"],
            ["🕞","Clock Face Three-Thirty"],
            ["🕓","Clock Face Four O'Clock"],
            ["🕟","Clock Face Four-Thirty"],
            ["🕔","Clock Face Five O'Clock"],
            ["🕠","Clock Face Five-Thirty"],
            ["🕕","Clock Face Six O'Clock"],
            ["🕡","Clock Face Six-Thirty"],
            ["🕖","Clock Face Seven O'Clock"],
            ["🕢","Clock Face Seven-Thirty"],
            ["🕗","Clock Face Eight O'Clock"],
            ["🕣","Clock Face Eight-Thirty"],
            ["🕘","Clock Face Nine O'Clock"],
            ["🕤","Clock Face Nine-Thirty"],
            ["🕙","Clock Face Ten O'Clock"],
            ["🕥","Clock Face Ten-Thirty"],
            ["🕚","Clock Face Eleven O'Clock"],
            ["🕦","Clock Face Eleven-Thirty"],
            ["♈","Aries"],
            ["♉","Taurus"],
            ["♊","Gemini"],
            ["♋","Cancer"],
            ["♌","Leo"],
            ["♍","Virgo"],
            ["♎","Libra"],
            ["♏","Scorpius"],
            ["♐","Sagittarius"],
            ["♑","Capricorn"],
            ["♒","Aquarius"],
            ["♓","Pisces"],
            ["⛎","Ophiuchus"],
            ["🌀","Cyclone"],
            ["🎴","Flower Playing Cards"],
            ["♠","Black Spade Suit"],
            ["♥","Black Heart Suit"],
            ["♦","Black Diamond Suit"],
            ["♣","Black Club Suit"],
            ["🀄","Mahjong Tile Red Dragon"],
            ["🔇","Speaker With Cancellation Stroke"],
            ["🔈","Speaker"],
            ["🔉","Speaker With One Sound Wave"],
            ["🔊","Speaker With Three Sound Waves"],
            ["📢","Public Address Loudspeaker"],
            ["📣","Cheering Megaphone"],
            ["📯","Postal Horn"],
            ["🔔","Bell"],
            ["🔕","Bell With Cancellation Stroke"],
            ["🔀","Twisted Rightwards Arrows"],
            ["🔁","Clockwise Rightwards and Leftwards Open Circle Arrows"],
            ["🔂","Clockwise Rightwards and Leftwards Open Circle Arrows With Circled One Overlay"],
            ["▶","Black Right-Pointing Triangle"],
            ["⏩","Black Right-Pointing Double Triangle"],
            ["◀","Black Left-Pointing Triangle"],
            ["⏪","Black Left-Pointing Double Triangle"],
            ["🔼","Up-Pointing Small Red Triangle"],
            ["⏫","Black Up-Pointing Double Triangle"],
            ["🔽","Down-Pointing Small Red Triangle"],
            ["⏬","Black Down-Pointing Double Triangle"],
            ["⏹","Black Square for Stop"],
            ["📳","Vibration Mode"],
            ["📴","Mobile Phone Off"],
            ["#⃣","Keycap Number Sign"],
            ["0⃣","Keycap Digit Zero"],
            ["1⃣","Keycap Digit One"],
            ["2⃣","Keycap Digit Two"],
            ["3⃣","Keycap Digit Three"],
            ["4⃣","Keycap Digit Four"],
            ["5⃣","Keycap Digit Five"],
            ["6⃣","Keycap Digit Six"],
            ["7⃣","Keycap Digit Seven"],
            ["8⃣","Keycap Digit Eight"],
            ["9⃣","Keycap Digit Nine"],
            ["🔟","Keycap Ten"],
            ["📶","Antenna With Bars"],
            ["🎦","Cinema"],
            ["🔅","Low Brightness Symbol"],
            ["🔆","High Brightness Symbol"],
            ["⬆","Upwards Black Arrow"],
            ["↗","North East Arrow"],
            ["➡","Black Rightwards Arrow"],
            ["↘","South East Arrow"],
            ["⬇","Downwards Black Arrow"],
            ["↙","South West Arrow"],
            ["⬅","Leftwards Black Arrow"],
            ["↖","North West Arrow"],
            ["↕","Up Down Arrow"],
            ["↔","Left Right Arrow"],
            ["↩","Leftwards Arrow With Hook"],
            ["↪","Rightwards Arrow With Hook"],
            ["⤴","Arrow Pointing Rightwards Then Curving Upwards"],
            ["⤵","Arrow Pointing Rightwards Then Curving Downwards"],
            ["🔃","Clockwise Downwards and Upwards Open Circle Arrows"],
            ["🔄","Anticlockwise Downwards and Upwards Open Circle Arrows"],
            ["🔙","Back With Leftwards Arrow Above"],
            ["🔚","End With Leftwards Arrow Above"],
            ["🔛","On With Exclamation Mark With Left Right Arrow Above"],
            ["🔜","Soon With Rightwards Arrow Above"],
            ["🔝","Top With Upwards Arrow Above"],
            ["🔰","Japanese Symbol for Beginner"],
            ["⚛","Atom Symbol"],
            ["🕉","Om Symbol"],
            ["✡","Star of David"],
            ["☸","Wheel of Dharma"],
            ["☯","Yin Yang"],
            ["✝","Latin Cross"],
            ["☦","Orthodox Cross"],
            ["☪","Star and Crescent"],
            ["☮","Peace Symbol"],
            ["🔯","Six Pointed Star With Middle Dot"],
            ["♻","Black Universal Recycling Symbol"],
            ["☢","Radioactive Sign"],
            ["☣","Biohazard Sign"],
            ["⭕","Heavy Large Circle"],
            ["✅","White Heavy Check Mark"],
            ["☑","Ballot Box With Check"],
            ["✔","Heavy Check Mark"],
            ["✖","Heavy Multiplication X"],
            ["❌","Cross Mark"],
            ["❎","Negative Squared Cross Mark"],
            ["➕","Heavy Plus Sign"],
            ["➖","Heavy Minus Sign"],
            ["➗","Heavy Division Sign"],
            ["➰","Curly Loop"],
            ["➿","Double Curly Loop"],
            ["〽","Part Alternation Mark"],
            ["✳","Eight Spoked Asterisk"],
            ["✴","Eight Pointed Black Star"],
            ["❇","Sparkle"],
            ["‼","Double Exclamation Mark"],
            ["⁉","Exclamation Question Mark"],
            ["❓","Black Question Mark Ornament"],
            ["❔","White Question Mark Ornament"],
            ["❕","White Exclamation Mark Ornament"],
            ["❗","Heavy Exclamation Mark Symbol"],
            ["©","Copyright Sign"],
            ["®","Registered Sign"],
            ["™","Trade Mark Sign"],
            ["💯","Hundred Points Symbol"],
            ["🔞","No One Under Eighteen Symbol"],
            ["🔠","Input Symbol for Latin Capital Letters"],
            ["🔡","Input Symbol for Latin Small Letters"],
            ["🔢","Input Symbol for Numbers"],
            ["🔣","Input Symbol for Symbols"],
            ["🔤","Input Symbol for Latin Letters"],
            ["🅰","Negative Squared Latin Capital Letter A"],
            ["🆎","Negative Squared AB"],
            ["🅱","Negative Squared Latin Capital Letter B"],
            ["🆑","Squared CL"],
            ["🆒","Squared Cool"],
            ["🆓","Squared Free"],
            ["ℹ","Information Source"],
            ["🆔","Squared ID"],
            ["Ⓜ","Circled Latin Capital Letter M"],
            ["🆕","Squared New"],
            ["🆖","Squared NG"],
            ["🅾","Negative Squared Latin Capital Letter O"],
            ["🆗","Squared OK"],
            ["🅿","Negative Squared Latin Capital Letter P"],
            ["🆘","Squared SOS"],
            ["🆙","Squared Up With Exclamation Mark"],
            ["🆚","Squared Vs"],
            ["🈁","Squared Katakana Koko"],
            ["🈂","Squared Katakana Sa"],
            ["🈷","Squared CJK Unified Ideograph-6708"],
            ["🈶","Squared CJK Unified Ideograph-6709"],
            ["🈯","Squared CJK Unified Ideograph-6307"],
            ["🉐","Circled Ideograph Advantage"],
            ["🈹","Squared CJK Unified Ideograph-5272"],
            ["🈚","Squared CJK Unified Ideograph-7121"],
            ["🈲","Squared CJK Unified Ideograph-7981"],
            ["🉑","Circled Ideograph Accept"],
            ["🈸","Squared CJK Unified Ideograph-7533"],
            ["🈴","Squared CJK Unified Ideograph-5408"],
            ["🈳","Squared CJK Unified Ideograph-7a7a"],
            ["㊗","Circled Ideograph Congratulation"],
            ["㊙","Circled Ideograph Secret"],
            ["🈺","Squared CJK Unified Ideograph-55b6"],
            ["🈵","Squared CJK Unified Ideograph-6e80"],
            ["▪","Black Small Square"],
            ["▫","White Small Square"],
            ["◻","White Medium Square"],
            ["◼","Black Medium Square"],
            ["◽","White Medium Small Square"],
            ["◾","Black Medium Small Square"],
            ["⬛","Black Large Square"],
            ["⬜","White Large Square"],
            ["🔶","Large Orange Diamond"],
            ["🔷","Large Blue Diamond"],
            ["🔸","Small Orange Diamond"],
            ["🔹","Small Blue Diamond"],
            ["🔺","Up-Pointing Red Triangle"],
            ["🔻","Down-Pointing Red Triangle"],
            ["💠","Diamond Shape With a Dot Inside"],
            ["🔲","Black Square Button"],
            ["🔳","White Square Button"],
            ["⚪","Medium White Circle"],
            ["⚫","Medium Black Circle"],
            ["🔴","Large Red Circle"],
            ["🔵","Large Blue Circle"],
        ]
    },
    {
        icon: '🎌 ',
        title: 'Flags',
        icons: [
            ["🇦🇫","Flag for Afghanistan"],
            ["🇦🇽","Flag for Åland Islands"],
            ["🇦🇱","Flag for Albania"],
            ["🇩🇿","Flag for Algeria"],
            ["🇦🇸","Flag for American Samoa"],
            ["🇦🇩","Flag for Andorra"],
            ["🇦🇴","Flag for Angola"],
            ["🇦🇮","Flag for Anguilla"],
            ["🇦🇶","Flag for Antarctica"],
            ["🇦🇬","Flag for Antigua &amp; Barbuda"],
            ["🇦🇷","Flag for Argentina"],
            ["🇦🇲","Flag for Armenia"],
            ["🇦🇼","Flag for Aruba"],
            ["🇦🇨","Flag for Ascension Island"],
            ["🇦🇺","Flag for Australia"],
            ["🇦🇹","Flag for Austria"],
            ["🇦🇿","Flag for Azerbaijan"],
            ["🇧🇸","Flag for Bahamas"],
            ["🇧🇭","Flag for Bahrain"],
            ["🇧🇩","Flag for Bangladesh"],
            ["🇧🇧","Flag for Barbados"],
            ["🇧🇾","Flag for Belarus"],
            ["🇧🇪","Flag for Belgium"],
            ["🇧🇿","Flag for Belize"],
            ["🇧🇯","Flag for Benin"],
            ["🇧🇲","Flag for Bermuda"],
            ["🇧🇹","Flag for Bhutan"],
            ["🇧🇴","Flag for Bolivia"],
            ["🇧🇦","Flag for Bosnia &amp; Herzegovina"],
            ["🇧🇼","Flag for Botswana"],
            ["🇧🇻","Flag for Bouvet Island"],
            ["🇧🇷","Flag for Brazil"],
            ["🇮🇴","Flag for British Indian Ocean Territory"],
            ["🇻🇬","Flag for British Virgin Islands"],
            ["🇧🇳","Flag for Brunei"],
            ["🇧🇬","Flag for Bulgaria"],
            ["🇧🇫","Flag for Burkina Faso"],
            ["🇧🇮","Flag for Burundi"],
            ["🇰🇭","Flag for Cambodia"],
            ["🇨🇲","Flag for Cameroon"],
            ["🇨🇦","Flag for Canada"],
            ["🇮🇨","Flag for Canary Islands"],
            ["🇨🇻","Flag for Cape Verde"],
            ["🇧🇶","Flag for Caribbean Netherlands"],
            ["🇰🇾","Flag for Cayman Islands"],
            ["🇨🇫","Flag for Central African Republic"],
            ["🇪🇦","Flag for Ceuta &amp; Melilla"],
            ["🇹🇩","Flag for Chad"],
            ["🇨🇱","Flag for Chile"],
            ["🇨🇳","Flag for China"],
            ["🇨🇽","Flag for Christmas Island"],
            ["🇨🇵","Flag for Clipperton Island"],
            ["🇨🇨","Flag for Cocos Islands"],
            ["🇨🇴","Flag for Colombia"],
            ["🇰🇲","Flag for Comoros"],
            ["🇨🇬","Flag for Congo - Brazzaville"],
            ["🇨🇩","Flag for Congo - Kinshasa"],
            ["🇨🇰","Flag for Cook Islands"],
            ["🇨🇷","Flag for Costa Rica"],
            ["🇨🇮","Flag for Côte D’Ivoire"],
            ["🇭🇷","Flag for Croatia"],
            ["🇨🇺","Flag for Cuba"],
            ["🇨🇼","Flag for Curaçao"],
            ["🇨🇾","Flag for Cyprus"],
            ["🇨🇿","Flag for Czech Republic"],
            ["🇩🇰","Flag for Denmark"],
            ["🇩🇬","Flag for Diego Garcia"],
            ["🇩🇯","Flag for Djibouti"],
            ["🇩🇲","Flag for Dominica"],
            ["🇩🇴","Flag for Dominican Republic"],
            ["🇪🇨","Flag for Ecuador"],
            ["🇪🇬","Flag for Egypt"],
            ["🇸🇻","Flag for El Salvador"],
            ["🇬🇶","Flag for Equatorial Guinea"],
            ["🇪🇷","Flag for Eritrea"],
            ["🇪🇪","Flag for Estonia"],
            ["🇪🇹","Flag for Ethiopia"],
            ["🇪🇺","Flag for European Union"],
            ["🇫🇰","Flag for Falkland Islands"],
            ["🇫🇴","Flag for Faroe Islands"],
            ["🇫🇯","Flag for Fiji"],
            ["🇫🇮","Flag for Finland"],
            ["🇫🇷","Flag for France"],
            ["🇬🇫","Flag for French Guiana"],
            ["🇵🇫","Flag for French Polynesia"],
            ["🇹🇫","Flag for French Southern Territories"],
            ["🇬🇦","Flag for Gabon"],
            ["🇬🇲","Flag for Gambia"],
            ["🇬🇪","Flag for Georgia"],
            ["🇩🇪","Flag for Germany"],
            ["🇬🇭","Flag for Ghana"],
            ["🇬🇮","Flag for Gibraltar"],
            ["🇬🇷","Flag for Greece"],
            ["🇬🇱","Flag for Greenland"],
            ["🇬🇩","Flag for Grenada"],
            ["🇬🇵","Flag for Guadeloupe"],
            ["🇬🇺","Flag for Guam"],
            ["🇬🇹","Flag for Guatemala"],
            ["🇬🇬","Flag for Guernsey"],
            ["🇬🇳","Flag for Guinea"],
            ["🇬🇼","Flag for Guinea-Bissau"],
            ["🇬🇾","Flag for Guyana"],
            ["🇭🇹","Flag for Haiti"],
            ["🇭🇲","Flag for Heard &amp; McDonald Islands"],
            ["🇭🇳","Flag for Honduras"],
            ["🇭🇰","Flag for Hong Kong"],
            ["🇭🇺","Flag for Hungary"],
            ["🇮🇸","Flag for Iceland"],
            ["🇮🇳","Flag for India"],
            ["🇮🇩","Flag for Indonesia"],
            ["🇮🇷","Flag for Iran"],
            ["🇮🇶","Flag for Iraq"],
            ["🇮🇪","Flag for Ireland"],
            ["🇮🇲","Flag for Isle of Man"],
            ["🇮🇱","Flag for Israel"],
            ["🇮🇹","Flag for Italy"],
            ["🇯🇲","Flag for Jamaica"],
            ["🇯🇵","Flag for Japan"],
            ["🇯🇪","Flag for Jersey"],
            ["🇯🇴","Flag for Jordan"],
            ["🇰🇿","Flag for Kazakhstan"],
            ["🇰🇪","Flag for Kenya"],
            ["🇰🇮","Flag for Kiribati"],
            ["🇽🇰","Flag for Kosovo"],
            ["🇰🇼","Flag for Kuwait"],
            ["🇰🇬","Flag for Kyrgyzstan"],
            ["🇱🇦","Flag for Laos"],
            ["🇱🇻","Flag for Latvia"],
            ["🇱🇧","Flag for Lebanon"],
            ["🇱🇸","Flag for Lesotho"],
            ["🇱🇷","Flag for Liberia"],
            ["🇱🇾","Flag for Libya"],
            ["🇱🇮","Flag for Liechtenstein"],
            ["🇱🇹","Flag for Lithuania"],
            ["🇱🇺","Flag for Luxembourg"],
            ["🇲🇴","Flag for Macau"],
            ["🇲🇰","Flag for Macedonia"],
            ["🇲🇬","Flag for Madagascar"],
            ["🇲🇼","Flag for Malawi"],
            ["🇲🇾","Flag for Malaysia"],
            ["🇲🇻","Flag for Maldives"],
            ["🇲🇱","Flag for Mali"],
            ["🇲🇹","Flag for Malta"],
            ["🇲🇭","Flag for Marshall Islands"],
            ["🇲🇶","Flag for Martinique"],
            ["🇲🇷","Flag for Mauritania"],
            ["🇲🇺","Flag for Mauritius"],
            ["🇾🇹","Flag for Mayotte"],
            ["🇲🇽","Flag for Mexico"],
            ["🇫🇲","Flag for Micronesia"],
            ["🇲🇩","Flag for Moldova"],
            ["🇲🇨","Flag for Monaco"],
            ["🇲🇳","Flag for Mongolia"],
            ["🇲🇪","Flag for Montenegro"],
            ["🇲🇸","Flag for Montserrat"],
            ["🇲🇦","Flag for Morocco"],
            ["🇲🇿","Flag for Mozambique"],
            ["🇲🇲","Flag for Myanmar"],
            ["🇳🇦","Flag for Namibia"],
            ["🇳🇷","Flag for Nauru"],
            ["🇳🇵","Flag for Nepal"],
            ["🇳🇱","Flag for Netherlands"],
            ["🇳🇨","Flag for New Caledonia"],
            ["🇳🇿","Flag for New Zealand"],
            ["🇳🇮","Flag for Nicaragua"],
            ["🇳🇪","Flag for Niger"],
            ["🇳🇬","Flag for Nigeria"],
            ["🇳🇺","Flag for Niue"],
            ["🇳🇫","Flag for Norfolk Island"],
            ["🇲🇵","Flag for Northern Mariana Islands"],
            ["🇰🇵","Flag for North Korea"],
            ["🇳🇴","Flag for Norway"],
            ["🇴🇲","Flag for Oman"],
            ["🇵🇰","Flag for Pakistan"],
            ["🇵🇼","Flag for Palau"],
            ["🇵🇸","Flag for Palestinian Territories"],
            ["🇵🇦","Flag for Panama"],
            ["🇵🇬","Flag for Papua New Guinea"],
            ["🇵🇾","Flag for Paraguay"],
            ["🇵🇪","Flag for Peru"],
            ["🇵🇭","Flag for Philippines"],
            ["🇵🇳","Flag for Pitcairn Islands"],
            ["🇵🇱","Flag for Poland"],
            ["🇵🇹","Flag for Portugal"],
            ["🇵🇷","Flag for Puerto Rico"],
            ["🇶🇦","Flag for Qatar"],
            ["🇷🇪","Flag for Réunion"],
            ["🇷🇴","Flag for Romania"],
            ["🇷🇺","Flag for Russia"],
            ["🇷🇼","Flag for Rwanda"],
            ["🇼🇸","Flag for Samoa"],
            ["🇸🇲","Flag for San Marino"],
            ["🇸🇹","Flag for São Tomé &amp; Príncipe"],
            ["🇸🇦","Flag for Saudi Arabia"],
            ["🇸🇳","Flag for Senegal"],
            ["🇷🇸","Flag for Serbia"],
            ["🇸🇨","Flag for Seychelles"],
            ["🇸🇱","Flag for Sierra Leone"],
            ["🇸🇬","Flag for Singapore"],
            ["🇸🇽","Flag for Sint Maarten"],
            ["🇸🇰","Flag for Slovakia"],
            ["🇸🇮","Flag for Slovenia"],
            ["🇸🇧","Flag for Solomon Islands"],
            ["🇸🇴","Flag for Somalia"],
            ["🇿🇦","Flag for South Africa"],
            ["🇬🇸","Flag for South Georgia &amp; South Sandwich Islands"],
            ["🇰🇷","Flag for South Korea"],
            ["🇸🇸","Flag for South Sudan"],
            ["🇪🇸","Flag for Spain"],
            ["🇱🇰","Flag for Sri Lanka"],
            ["🇧🇱","Flag for St. Barthélemy"],
            ["🇸🇭","Flag for St. Helena"],
            ["🇰🇳","Flag for St. Kitts &amp; Nevis"],
            ["🇱🇨","Flag for St. Lucia"],
            ["🇲🇫","Flag for St. Martin"],
            ["🇵🇲","Flag for St. Pierre &amp; Miquelon"],
            ["🇻🇨","Flag for St. Vincent &amp; Grenadines"],
            ["🇸🇩","Flag for Sudan"],
            ["🇸🇷","Flag for Suriname"],
            ["🇸🇯","Flag for Svalbard &amp; Jan Mayen"],
            ["🇸🇿","Flag for Swaziland"],
            ["🇸🇪","Flag for Sweden"],
            ["🇨🇭","Flag for Switzerland"],
            ["🇸🇾","Flag for Syria"],
            ["🇹🇼","Flag for Taiwan"],
            ["🇹🇯","Flag for Tajikistan"],
            ["🇹🇿","Flag for Tanzania"],
            ["🇹🇭","Flag for Thailand"],
            ["🇹🇱","Flag for Timor-Leste"],
            ["🇹🇬","Flag for Togo"],
            ["🇹🇰","Flag for Tokelau"],
            ["🇹🇴","Flag for Tonga"],
            ["🇹🇹","Flag for Trinidad &amp; Tobago"],
            ["🇹🇦","Flag for Tristan Da Cunha"],
            ["🇹🇳","Flag for Tunisia"],
            ["🇹🇷","Flag for Turkey"],
            ["🇹🇲","Flag for Turkmenistan"],
            ["🇹🇨","Flag for Turks &amp; Caicos Islands"],
            ["🇹🇻","Flag for Tuvalu"],
            ["🇺🇬","Flag for Uganda"],
            ["🇺🇦","Flag for Ukraine"],
            ["🇦🇪","Flag for United Arab Emirates"],
            ["🇬🇧","Flag for United Kingdom"],
            ["🇺🇸","Flag for United States"],
            ["🇺🇾","Flag for Uruguay"],
            ["🇺🇲","Flag for U.S. Outlying Islands"],
            ["🇻🇮","Flag for U.S. Virgin Islands"],
            ["🇺🇿","Flag for Uzbekistan"],
            ["🇻🇺","Flag for Vanuatu"],
            ["🇻🇦","Flag for Vatican City"],
            ["🇻🇪","Flag for Venezuela"],
            ["🇻🇳","Flag for Vietnam"],
            ["🇼🇫","Flag for Wallis &amp; Futuna"],
            ["🇪🇭","Flag for Western Sahara"],
            ["🇾🇪","Flag for Yemen"],
            ["🇿🇲","Flag for Zambia"],
            ["🇿🇼","Flag for Zimbabwe"],
        ]
    }
];


// WEBPACK FOOTER //
// ./src/jquery/widgets/emojis.js